module.exports = __webpack_public_path__ + "img/account_heart.7131b647.svg";